module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.7c8d04c.ttf";